import React from 'react'

/**
 * This hook is used to merge several react refs into a single one.
 */
export const useMergedRefs = <T,>(refs: React.ForwardedRef<T>[]): React.ForwardedRef<T> =>
    React.useCallback(
        (current) => {
            refs.forEach((ref) => {
                if (typeof ref === 'function') {
                    ref(current)
                } else if (ref && !Object.isFrozen(ref)) {
                    ref.current = current
                }
            })
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [JSON.stringify(refs)]
    )
